module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"footer":"Слишком часто видите эту страницу?","feedback":"Напишите нам!","submit":"Подтвердить","text":"Мы заметили подозрительную активность с вашей стороны. Пожалуйста, подтвердите, что вы не робот.","meta":{"title":"Aromo"}}}')
  delete Component.options._Ctor
}
